export default __webpack_public_path__ + "static/media/texPokemons.c49770da.jpg";